import Bus from '@/assets/js/bus.js';
export default {
  data() {
    return {
      disconnected: false,
      // 网络质量
      netWork: {
        upLinkNetWork: '',
        downLinkNetWork: ''
      },
      netWorkIconColor: '',
      remoteNetWork: {},
      remoteNetWorkIconColor: ''
    };
  },
  computed: {
    bgColor() {
      if (this.netWorkIconColor === 'Green') {
        return 'bgGreen';
      } else if (this.netWorkIconColor === 'Orange') {
        return 'bgOrange';
      } else if (this.netWorkIconColor === 'Red') {
        return 'bgRed';
      } else {
        return 'bgGreen';
      }
    }
  },
  created() {
    // 网络是否断开
    Bus.$on('disconnected', curState => {
      if (curState == 'RECONNECTING' || curState == 'DISCONNECTED') {
        this.disconnected = true;
      } else if (curState == 'CONNECTED') {
        this.disconnected = false;
      }
    });
    // 本地用户网络质量
    Bus.$on('downlinkNetworkQuality', downlinkNetworkQuality => {
      if (downlinkNetworkQuality < 3) {
        this.netWork.downLinkNetWork = 'Good';
      } else if (downlinkNetworkQuality > 4) {
        this.netWork.downLinkNetWork = 'Poor';
      } else {
        this.netWork.downLinkNetWork = 'Mid';
      }
      this.dealNetWorkQuality(this.netWork);
      this.$emit('callback', this.netWork);
    });
    Bus.$on('uplinkNetworkQuality', uplinkNetworkQuality => {
      if (uplinkNetworkQuality < 3) {
        this.netWork.upLinkNetWork = 'Good';
      } else if (uplinkNetworkQuality > 4) {
        this.netWork.upLinkNetWork = 'Poor';
      } else {
        this.netWork.upLinkNetWork = 'Mid';
      }
      this.dealNetWorkQuality(this.netWork);
      this.$emit('callback', this.netWork);
    });
  },
  methods: {
    dealNetWorkQuality(netWork) {
      if (netWork.upLinkNetWork === 'Good' && netWork.downLinkNetWork === 'Good') {
        this.netWorkIconColor = 'Green';
      } else if (netWork.upLinkNetWork === 'Good' && netWork.downLinkNetWork === 'Mid') {
        this.netWorkIconColor = 'Orange';
      } else if (netWork.upLinkNetWork === 'Mid' && netWork.downLinkNetWork === 'Good') {
        this.netWorkIconColor = 'Orange';
      } else if (netWork.upLinkNetWork === 'Mid' && netWork.downLinkNetWork === 'Mid') {
        this.netWorkIconColor = 'Orange';
      } else if (netWork.upLinkNetWork === 'Poor' || netWork.downLinkNetWork === 'Poor') {
        this.netWorkIconColor = 'Red';
      }
    }
  }
};